import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "grid-content" }
const _hoisted_3 = { class: "grid-content" }
const _hoisted_4 = { class: "data-box" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "right-data" }
const _hoisted_7 = { class: "data-num" }
const _hoisted_8 = { class: "data-title" }
const _hoisted_9 = { class: "shelf-data" }
const _hoisted_10 = {
  class: "left-data",
  style: {"width":"60%"}
}
const _hoisted_11 = { class: "operate-down" }
const _hoisted_12 = { class: "shelf-data-title" }
const _hoisted_13 = { class: "shelf-data-content" }
const _hoisted_14 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_15 = { class: "data-num" }
const _hoisted_16 = { class: "data-title" }
const _hoisted_17 = { class: "rank-data" }

import { getCurrentInstance, ref, onMounted, reactive,computed} from 'vue'
import { useStore } from '@/store/index'
import * as echarts from 'echarts'
import { Top, Bottom } from '@element-plus/icons-vue'
import { getDelayTime, dateFormat } from '@/utils/index'
import { BrandCat } from '@/enums/brand'
import { getBrandListApi } from '@/apis/brand'
import { BrandM } from '@/models/brand'
import RankTable from '@/components/RankTable.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'GeneralControlData',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const hasShop = store.state.user.userInfo
const today = new Date()
const current = dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() - 1}`);
const filters = reactive({
    start_date: dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-1`), //开始日期
    end_date: dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() - 1}`), //结束日期
    cat_id:'',
    province_id:'',
    city_id:'',   
    brand_id:'',
    type: 1,
})
const brandProps = {
    value: 'id',
    label: 'name'
}
const detailsData = reactive({
    onSaleGoods:'', //在售商品
    salesAmount:'', //销售额
    waitSendOrder:'', //待发货订单
    orderNum:'', //订单数
    cakeOrderNum:'', //蛋糕订单数
    snackOrderNum: '', //零食订单数
    flowerOrderNum: '', //鲜花订单数
    couponOrderNum: '', //电子券订单数
    onlineBrand: '', //线上品牌
    onlineCakeBrand: '', //线上蛋糕品牌
    onlineFlowerBrand: '', //线上鲜花品牌
    onlineSnackBrand: '', //线上零食品牌
    onlineCouponBrand: '', //线上电子券品牌
    onShelfGoods: '', //上架商品
    onShelfCakeGoods: '', //上架蛋糕商品
    onShelfFlowerGoods: '', //上架鲜花商品
    onShelfSnackGoods: '', //上架零食商品
    onShelfCouponGoods: '', //上架电子券商品
    unitPrice: '', //客单价
})
const shelf = reactive({
    brandExpired: '', //品牌过期
    brandExpired_rate: '', //品牌过期率
    delaySend: '', //延迟发货
    delaySend_rate: '', //延迟发货率
    descriptionNotFit: '', //信息有误
    descriptionNotFit_rate: '', //信息有误率
    discountNotFit: '', //折扣不匹配
    discountNotFit_rate: '', //折扣不匹配率
    merchantOffShelf: '', //商家下架
    merchantOffShelf_rate: '', //商家下架率
    premiumNum: '', //商品溢价
    premiumNum_rate: '', //商品溢价率
    qualityProblem: '', //质量有问题
    qualityProblem_rate: '', //质量有问题率
    tasteNotGood: '', //口感不佳
    tasteNotGood_rate: '', //口感不佳率
})
const dataRows = computed(() => [
        {
            dataRow: [
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014140656_456.png", number: detailsData.onSaleGoods, title: "在售商品", bgColor: "#f8fbff", iconBgColor: "#e5effd" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014142126_224.png", number: detailsData.salesAmount, title: "销售额", bgColor: "#fff8f7", iconBgColor: "#ffebe8" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014142301_849.png", number: detailsData.waitSendOrder, title: "待发货订单", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },
            ]
        },
        {
            dataRow: [
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014145102_392.png", number: detailsData.orderNum, title: "订单数量", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014145318_168.png", number: detailsData.cakeOrderNum, title: "蛋糕订单", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014145327_535.png", number: detailsData.snackOrderNum, title: "零食订单", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014145620_932.png", number: detailsData.flowerOrderNum, title: "鲜花订单", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014145708_778.png", number: detailsData.couponOrderNum, title: "电子券订单", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },

            ]
        },
        {
            dataRow: [
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014150531_172.png", number: detailsData.onlineBrand, title: "线上品牌", bgColor: "#f7fdfa", iconBgColor: "#dcf8ec" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014150902_50.png", number:  detailsData.onlineCakeBrand,  title: "线上蛋糕品牌", bgColor: "#f7fdfa", iconBgColor: "#dcf8ec" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014150909_791.png", number: detailsData.onlineSnackBrand, title: "线上零食品牌", bgColor: "#f7fdfa", iconBgColor: "#dcf8ec" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014114359_218.png", number: detailsData.onlineFlowerBrand, title: "线上鲜花品牌", bgColor: "#f7fdfa", iconBgColor: "#dcf8ec" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014150923_855.png", number: detailsData.onlineCouponBrand, title: "线上电子券品牌", bgColor: "#f7fdfa", iconBgColor: "#dcf8ec" },
            ]
        },
        {
            dataRow: [
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014151415_288.png", number: detailsData.onShelfGoods, title: "上架总商品", bgColor: "#f8fbff", iconBgColor: "#e5effd" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014151554_328.png", number: detailsData.onShelfCakeGoods, title: "上架蛋糕商品", bgColor: "#f8fbff", iconBgColor: "#e5effd" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014151602_610.png", number: detailsData.onShelfSnackGoods, title: "上架零食商品", bgColor: "#f8fbff", iconBgColor: "#e5effd" },
                { icon: "https://image-oss.dangaoss.cn/common/common_20241014151610_762.png", number: detailsData.onShelfFlowerGoods, title: "上架鲜花商品", bgColor: "#f8fbff", iconBgColor: "#e5effd" },
            ]
        },
]);
const dataFiltersRows = computed(() => {
    const filterByCategory = (row, index) => {
        // 第一行的所有数据始终返回
        if (index === 0) {
            return row.dataRow;
        }

        // 其他行的过滤逻辑
        return [row.dataRow[0], ...row.dataRow.slice(1).filter(item => {
            if ((filters.cat_id == 1 || state.brand_cat == 1) && item.title.includes('蛋糕')) {
                return true;
            } else if ((filters.cat_id == 5 || state.brand_cat == 5) && item.title.includes('零食')) {
                return true;
            } else if ((filters.cat_id == 8 || state.brand_cat == 8) && item.title.includes('鲜花')) {
                return true;
            } else if ((filters.cat_id == 4 || state.brand_cat == 4) && item.title.includes('电子券')) {
                return true;
            }
            return !filters.cat_id && !state.brand_cat; // 如果没有选择任何类别，则显示所有数据
        })];
    }
    return dataRows.value.map((row, index) => ({
        ...row,
        dataRow: filterByCategory(row, index)
    })).filter(row => row.dataRow.length > 0);
});
const shelfData = computed(() => [
        {
            title: "运营下架",
            items: [
                { value: shelf.premiumNum, label: "商品溢价", tagColor: "#1f81ff" },
                { value: shelf.discountNotFit, label: "折扣不合格", tagColor: "#1f81ff" },
                { value: shelf.descriptionNotFit, label:"信息有误", tagColor: "#1f81ff" },
                { value: shelf.qualityProblem, label: "质量问题", tagColor: "#1f81ff" },
                { value: shelf.tasteNotGood, label: "口感不佳", tagColor: "#1f81ff" },
            ]
        },
        {
            title: "商户下架",
            items: [
                { value: shelf.merchantOffShelf,label: "自行下架", tagColor: "#00bbb0" },
                { value: shelf.delaySend,label: "延迟发货", tagColor: "#00bbb0" },
                { value: shelf.brandExpired,label: "品牌资质过期", tagColor: "#00bbb0" },
            ]
        }
])
const state = reactive({
    brand_cat:'',
    cakeBrandData: [
    // 蛋糕品牌排行榜数据
    ],
    couponData: [
    // 电子券排行榜数据
    ],
    snackMerchantData: [
    // 零食商户排行榜数据
    ],
    secondaryBrandData: [
    // 零食二级品牌排行榜数据
    ]
})
const getList = () => {
    proxy.$http.get('/data/operate_basics_data', filters).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        Object.assign(detailsData, data)
    })
    proxy.$http.get('/data/brand_ranking', filters).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        state.cakeBrandData = data.cake
        state.couponData = data.coupon
        state.snackMerchantData = data.snack
        state.secondaryBrandData = data.Second_brand
    })
}
const getBarList = () => {
    proxy.$http.get('/data/operate_offShelfGoods', filters).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        Object.assign(shelf, data)
        // initBarEcharts()
    })
}
getList()
getBarList()
const search = () => {
    if (filters.start_date && filters.end_date) {
        if (filters.end_date >= filters.start_date) {
            getList()
            getBarList()
        } else {
            proxy.$message({ type: 'error', message: '结束时间不能早于开始时间' })
        }
    }else{
        proxy.$message({ type: 'error', message: '日期不能为空' })
    }
}
//@ts-ignore
const disabledStartDate = (date) => { // 返回开始不可用日期
    //所选时间小于等于当前日期
    var start = date.getTime() + 24 * 60 * 60 * 1000
    var current = Date.now()
    return start > current
}
//@ts-ignore
const disabledEndDate = (date) => { // 返回结束不可用日期
    //@ts-ignore
    var start = new Date(filters.start_time).getTime()
    //所选时间小于等于当前日期
    //@ts-ignore
    var end = date.getTime() + 24 * 60 * 60 * 1000
    var current = Date.now()
    //所选时间小于等于当前日期或小于开始日期
    return end > current || end < start
}
const onBrandChange = (val) => {
    filters.brand_id = val
    if(val){
        state.brand_cat = brandList.value.find(item => item.id == val).cat_id   
    }else{
        state.brand_cat =''
    }
}
// 获取城市列表
const cityList = ref<any[]>([])
const getCityList = () => {
    proxy.$http.get(`/cake_api/getCityListByBrandId?brand_id=${filters.brand_id}`).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        cityList.value = data
        // if (data.length > 0) {
        //     filters.city_id = data[0].options[0].id
        // }
    })
}
getCityList()
const brandList = ref<BrandM[]>([])
// 获取品牌列表
const getBrandList = () =>{
    const{ city_id,cat_id } = filters
    proxy.$http.get('/admin/shop_product/getBrandList', {city_id: city_id, cat_id: cat_id}).then((res:any) => {
        // const { code, data, msg } = res
        if (res.code != 200) { return proxy.$message({ type: 'error', message: res.msg }) }
        brandList.value = res.data                  
    })
}
const handleCatChange = (value) => {
    filters.brand_id = ''
    filters.cat_id = value
    getBrandList() 
    state.brand_cat = ''
    // getList()
}
getBrandList()
const handleClear = () => {
    state.brand_cat = ''
}
const initBarEcharts = () => {
    //  基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(document.getElementById('shelf-data')!);
    // 指定图表的配置项和数据
    let option = {
        title: {
        left: 'right'
        },
        tooltip: {
        trigger: 'item',
        formatter: function(params) {
            const isOperationOffShelf = params.dataIndex < 5;
            const group = isOperationOffShelf ? '运营下架' : '商户下架';
            return `${group}<br>${params.name} &nbsp&nbsp ${params.value}`;
        }
        },
        series: [
        {
            name: '下架商品',
            type: 'pie',
            radius: '100%',
            data: [
            { value: shelf.premiumNum, name: `商品溢价 ${shelf.premiumNum_rate}` },
            { value: shelf.discountNotFit, name: `折扣不合格 ${shelf.discountNotFit_rate}` },
            { value: shelf.descriptionNotFit, name: `信息有误 ${shelf.descriptionNotFit_rate}` },
            { value: shelf.qualityProblem, name: `质量问题 ${shelf.qualityProblem_rate}` },
            { value: shelf.tasteNotGood, name: `口感不佳 ${shelf.tasteNotGood_rate}` },
            { value: shelf.merchantOffShelf, name: `自行下架 ${shelf.merchantOffShelf_rate}` },
            { value: shelf.delaySend, name: `延迟发货 ${shelf.delaySend_rate}` },
            { value: shelf.brandExpired, name: `品牌资质过期 ${shelf.brandExpired_rate}` }
            ],
            emphasis: {
            itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
            }
        }
        ]
    };
    option && myChart.setOption(option);
}
const maxWidth = ref('auto');

const calculateMaxWidth = () => {
  let maxItemWidth = 0;

  const items = document.querySelectorAll('.data-item');
  items.forEach(item => {
    const rect = item.getBoundingClientRect();
    if (rect.width > maxItemWidth) {
      maxItemWidth = rect.width;
    }
  });

  maxWidth.value = `${maxItemWidth}px`;
};

onMounted(() => {
  calculateMaxWidth();
  window.addEventListener('resize', calculateMaxWidth);
});

return (_ctx: any,_cache: any) => {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, {
      offset: 0,
      style: {"background-color":"#fff","height":"130px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"margin-top":"10px","padding":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  class: "filter-item",
                  modelValue: filters.brand_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.brand_id) = $event)),
                  placeholder: "请选择品牌",
                  filterable: "",
                  clearable: "",
                  style: {"width":"200px"},
                  props: brandProps,
                  options: brandList.value,
                  onChange: onBrandChange,
                  onClear: handleClear
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: filters.cat_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.cat_id) = $event)),
                  clearable: "",
                  filterable: "",
                  placeholder: "请选择类型",
                  class: "filter-item",
                  style: {"width":"150px"},
                  onChange: handleCatChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "蛋糕",
                      value: _unref(BrandCat)['蛋糕']
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "零食",
                      value: _unref(BrandCat)['零食']
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "鲜花",
                      value: _unref(BrandCat)['鲜花']
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "电子券",
                      value: 4
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: filters.city_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.city_id) = $event)),
                  filterable: "",
                  placeholder: "请选择城市",
                  autocomplete: "no",
                  style: {"width":"200px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        key: group.lable,
                        label: group.lable
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.lable,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { style: {"padding":"0px 20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text" }, "选择日期：", -1)),
                  _createVNode(_component_el_date_picker, {
                    class: "filter-item",
                    type: "date",
                    modelValue: filters.start_date,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.start_date) = $event)),
                    "disabled-date": disabledStartDate,
                    placeholder: "开始日期",
                    "value-format": "YYYY-MM-DD",
                    style: {"width":"170px"},
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text" }, " - ", -1)),
                  _createVNode(_component_el_date_picker, {
                    class: "filter-item",
                    type: "date",
                    modelValue: filters.end_date,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.end_date) = $event)),
                    "disabled-date": disabledEndDate,
                    placeholder: "结束日期",
                    "value-format": "YYYY-MM-DD",
                    style: {"width":"170px"},
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    class: "filter-btn",
                    type: "primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (search()))
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("搜索")
                    ])),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataFiltersRows.value, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "data-row",
          key: rowIndex
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.dataRow, (item, itemIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "data-item",
              key: itemIndex,
              style: _normalizeStyle({ backgroundColor: item.bgColor,width: maxWidth.value })
            }, [
              _createElementVNode("div", {
                class: "left-icon",
                style: _normalizeStyle({ backgroundColor: item.iconBgColor })
              }, [
                _createElementVNode("img", {
                  src: item.icon,
                  alt: ""
                }, null, 8, _hoisted_5)
              ], 4),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.number), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1)
              ])
            ], 4))
          }), 128))
        ]))
      }), 128))
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "model-title" }, [
      _createElementVNode("div", { class: "shelf-data-title" }, "下架商品（以品牌、类型、统计商品情况）")
    ], -1)),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shelfData.value, (content, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            style: {"margin-left":"10px"}
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(content.title), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.items, (item, itemIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: itemIndex,
                  class: "shelf-data-item"
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: "tag",
                      style: _normalizeStyle({ backgroundColor: item.tagColor })
                    }, null, 4),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(item.label), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(item.value), 1)
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "model-title" }, [
      _createElementVNode("div", { class: "shelf-data-title" }, "排行榜（以时间维度统计）")
    ], -1)),
    _createElementVNode("div", _hoisted_17, [
      (!filters.cat_id && !state.brand_cat || filters.cat_id ==1 || state.brand_cat == 1)
        ? (_openBlock(), _createBlock(RankTable, {
            key: 0,
            title: "蛋糕品牌排行榜",
            data: state.cakeBrandData,
            columns: [
                { prop: 'brand_id', label: '品牌ID' },
                { prop: 'brand_name', label: '品牌名称' },
                { prop: 'maoli', label: '毛利率' }
            ]
          }, null, 8, ["data"]))
        : _createCommentVNode("", true),
      (!filters.cat_id && !state.brand_cat || filters.cat_id == 4 || state.brand_cat == 4)
        ? (_openBlock(), _createBlock(RankTable, {
            key: 1,
            title: "电子券排行榜",
            data: state.couponData,
            columns: [
                { prop: 'coupon_id', label: '商品ID' },
                { prop: 'coupon_name', label: '商品名称' },
                { prop: 'maoli', label: '毛利率' }
            ]
          }, null, 8, ["data"]))
        : _createCommentVNode("", true),
      (!filters.cat_id && !state.brand_cat || filters.cat_id == 5 || state.brand_cat == 5)
        ? (_openBlock(), _createBlock(RankTable, {
            key: 2,
            title: "零食商户排行榜",
            data: state.snackMerchantData,
            columns: [
                { prop: 'merchant_id', label: '商户ID' },
                { prop: 'merchant_name', label: '商户名称' },
                { prop: 'maoli', label: '毛利率' }
            ]
          }, null, 8, ["data"]))
        : _createCommentVNode("", true),
      (!filters.cat_id && !state.brand_cat || filters.cat_id == 5 || state.brand_cat == 5)
        ? (_openBlock(), _createBlock(RankTable, {
            key: 3,
            title: "零食二级品牌排行榜",
            data: state.secondaryBrandData,
            columns: [
                { prop: 'secondary_brand_id', label: '二级品牌ID' },
                { prop: 'secondary_brand_name', label: '二级品牌名称' },
                { prop: 'maoli', label: '毛利率' }
            ]
          }, null, 8, ["data"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})